// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"9c573cb7","848":"089a5ea3"}[chunkId] + ".chunk.css";
};